import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../../../../../commons/services/common.service';
import { ConstanteEcorec } from '../../../../../application/constante.ecorec';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-transporteur-logo',
  templateUrl: './transporteur-logo.component.html',
  styleUrls: ['./transporteur-logo.component.css']
})
export class TransporteurLogoComponent implements OnInit {

  public transporteur: any = {}; // l'objet principal
  public rowSelect: any = {};
  fileToAdd: any = {};
  objFileObject: any = {};
  cheminLogo: any = '';
  public loadingIndicator: Boolean = false;
  isEmpty: Boolean = false;
  error = '';
  @Output() public callback: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  set setTransporteur(val: any) {
    this.transporteur = val;
    if (this.transporteur['id'])
      this.getLogo();
  }

  @ViewChild('msg') msg;
  constructor(public common: CommonService, public modalService: BsModalService) {

  }

  ngOnInit() {
  }

  showInput(index?) {
    const ctrl = this;
  }

  annuler() {
    this.callback.emit();
  }

  save() {
    const ctrl = this;
    this.saveLogo();
    // this.transporteur.fichierLogo['nomFichier'] = null;
    // console.log(this.transporteur);
    this.callback.emit();
  }

  getNameFile(event, item) {
    const file = event.target.files[0];

    if (!this.common.checkExtFichierImgEtTexte(file.name)) {
      this.error = this.common.msgErreurExtensionFichier;
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    item.nomFichier = file.name;
    item.type = file.type;
    item.taille = file.size;
    item['nomclass'] = 'FileObject';

    const fileReader = new FileReader();
    const ctrl = this;

    fileReader.onload = function () {
      const result = fileReader.result;
      if (typeof result === 'string') {
        const base64 = result.split(',');
        item.contentBase64 = base64[1];
        ctrl.cheminLogo = result;
        ctrl.objFileObject = item;
      }
    };

    fileReader.readAsDataURL(file);
  }

  getLogo() {
    const param = {
      'servlet': 'DBGestionLogo',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'TABLE': 'transporteur',
        'COLONNE': 'imageTampon',
        'COLONNE_CLEF': 'clefTransporteur',
        'CLEF': {
          'typeParam': 'int',
          'valeur': this.transporteur.id
        },
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas) && datas.data != null) {
        this.cheminLogo = datas.data.NOM_FICHIER ? this.common.intercept(datas.data.NOM_FICHIER) : '';
      }
    });
  }

  saveLogo() {
    const param = {
      'servlet': 'DBGestionLogo',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'TABLE': 'transporteur',
        'COLONNE': 'imageTampon',
        'COLONNE_CLEF': 'clefTransporteur',
        'CLEF': {
          'typeParam': 'int',
          'valeur': this.transporteur.id
        },
        'FICHIER': this.objFileObject,
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas) && datas.data != null) {
        this.transporteur['imageTampon'] = this.objFileObject['nomFichier'];
        this.transporteur['nomImageTampon'] = this.objFileObject['nomFichier'];
        // console.log('saveLogo()');
        // console.log(this.objFileObject);         
      }
    });
  }

  deleteLogo() {
    const ctrl = this;
    const param = {
      'servlet': 'DBGestionLogo',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'TABLE': 'transporteur',
        'COLONNE': 'nomFichierLogo',
        'COLONNE_CLEF': 'clefTransporteur',
        'CLEF': {
          'typeParam': 'int',
          'valeur': this.transporteur.id
        },
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas) && datas.data != null) {
        ctrl.cheminLogo = "";
      }
    });
  }
}
